/* Precision Kart Mega Menu — v9 */

function pmmInit() {
  const root = document.getElementById('pmm');
  if (!root) { setTimeout(pmmInit, 200); return; }

  const burger = root.querySelector('[data-pmm-burger]');
  const drawer = root.querySelector('[data-pmm-drawer]');
  const closeBtn = root.querySelector('[data-pmm-close]');
  const scrim = root.querySelector('[data-pmm-scrim]');

  const searchWrap = root.querySelector('[data-pmm-search]');
  const searchOpenBtn = root.querySelector('[data-pmm-search-open]');
  const searchInput = root.querySelector('[data-pmm-search-input]');
  const searchCloseBtn = root.querySelector('[data-pmm-search-close]');
  const searchPanel = root.querySelector('[data-pmm-search-panel]');
  const stateResults = root.querySelector('[data-pmm-search-results]');
  const stateNoResults = root.querySelector('[data-pmm-search-empty-results]');

  const msearchOpenBtn = root.querySelector('[data-pmm-msearch-open]');
  const msearch = root.querySelector('[data-pmm-msearch]');
  const msearchInput = root.querySelector('[data-pmm-msearch-input]');
  const msearchClose = root.querySelector('[data-pmm-msearch-close]');
  const msearchResults = root.querySelector('[data-pmm-msearch-results]');

  console.log('[pmm] initialised');

  const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;

  // Generic dropdown handler — any item with data-pmm-dropdown opens its matching data-pmm-panel
  const dropdownItems = root.querySelectorAll('[data-pmm-dropdown]');
  let activeDropdown = null;
  let openTimer, closeTimer;

  function getPanel(key) { return root.querySelector(`[data-pmm-panel="${key}"]`); }

  function openDropdown(item) {
    const key = item.getAttribute('data-pmm-dropdown');
    const panel = getPanel(key);
    if (!panel) return;
    closeAllDropdowns();
    clearTimeout(closeTimer);
    panel.hidden = false;
    clearTimeout(panel._pmmHideTimer); // fix: cancel pending hide from a previous close
    item._pmmOpenedAt = Date.now();
    requestAnimationFrame(() => panel.classList.add('is-open'));
    item.classList.add('is-open');
    const btn = item.querySelector('.pmm__primary-link');
    if (btn) btn.setAttribute('aria-expanded', 'true');

    // For simple panels, anchor under the button
    if (panel.classList.contains('pmm__simple-panel')) {
      const rect = item.getBoundingClientRect();
      panel.style.left = rect.left + 'px';
    }
    activeDropdown = item;
  }

  function closeDropdown(item) {
    const key = item.getAttribute('data-pmm-dropdown');
    const panel = getPanel(key);
    if (!panel) return;
    panel.classList.remove('is-open');
    item.classList.remove('is-open');
    const btn = item.querySelector('.pmm__primary-link');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    clearTimeout(panel._pmmHideTimer);panel._pmmHideTimer = setTimeout(() => { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 180); // fix: only hide if still closed
    if (activeDropdown === item) activeDropdown = null;
  }

  function closeAllDropdowns() {
    dropdownItems.forEach(item => {
      if (item.classList.contains('is-open')) closeDropdown(item);
    });
  }

  dropdownItems.forEach(item => {
    const key = item.getAttribute('data-pmm-dropdown');
    const panel = getPanel(key);
    if (!panel) return;
    const btn = item.querySelector('.pmm__primary-link');

    item.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      clearTimeout(closeTimer);
      if (!item.classList.contains('is-open')) openTimer = setTimeout(() => openDropdown(item), 60); // fix: don't re-open an already open panel
    });
    item.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      if (isMobile()) return;
      closeTimer = setTimeout(() => closeDropdown(item), 200);
    });
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => closeDropdown(item), 200); });

    if (btn) btn.addEventListener('click', (e) => {
      if (isMobile()) return;
      e.preventDefault();
    if (!item.classList.contains('is-open')) openDropdown(item); // fix: on desktop a click only opens (moving the mouse away closes)
    });
  });

  // MOBILE DRAWER
  if (burger && drawer && scrim) {
    const openDrawer = () => {
      drawer.hidden = false; scrim.hidden = false;
      requestAnimationFrame(() => { drawer.classList.add('is-open'); scrim.classList.add('is-open'); });
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    const closeDrawerFn = () => {
      drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => { if (!drawer.classList.contains('is-open')) scrim.hidden = true; }, 280); // fix: don't hide scrim if drawer reopened
    };
    burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawerFn);
    scrim.addEventListener('click', closeDrawerFn);
    window.addEventListener('resize', () => { if (window.innerWidth > 1024 && drawer.classList.contains('is-open')) closeDrawerFn(); });
  }

  // DESKTOP SEARCH
  const openSearch = () => {
    closeAllDropdowns();
    searchWrap.classList.add('is-open');
    setTimeout(() => searchInput && searchInput.focus(), 200);
  };
  const closeSearch = () => {
    searchWrap.classList.remove('is-open');
    searchPanel.classList.remove('is-open');
    setTimeout(() => { searchPanel.hidden = true; }, 200);
    if (searchInput) searchInput.value = '';
    hideAllStates();
  };
  const hideAllStates = () => {
    if (stateResults) { stateResults.hidden = true; stateResults.innerHTML = ''; }
    if (stateNoResults) stateNoResults.hidden = true;
  };
  const showPanel = () => { searchPanel.hidden = false; requestAnimationFrame(() => searchPanel.classList.add('is-open')); };
  const hidePanel = () => { searchPanel.classList.remove('is-open'); setTimeout(() => { searchPanel.hidden = true; }, 200); };

  if (searchOpenBtn) searchOpenBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

  let searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimer);
      const q = e.target.value.trim();
      if (!q) { hideAllStates(); hidePanel(); return; }
      searchTimer = setTimeout(() => runSearch(q, false), 200);
    });
  }

  document.addEventListener('click', (e) => {
    if (!searchWrap || !searchPanel) return;
    if (!searchWrap.classList.contains('is-open')) return;
    if (searchWrap.contains(e.target) || searchPanel.contains(e.target)) return;
    closeSearch();
  });

  // MOBILE SEARCH
  const openMSearch = () => {
    msearch.hidden = false;
    requestAnimationFrame(() => msearch.classList.add('is-open'));
    setTimeout(() => msearchInput && msearchInput.focus(), 300);
    document.body.style.overflow = 'hidden';
  };
  const closeMSearch = () => {
    msearch.classList.remove('is-open');
    msearch.classList.remove('has-results');
    setTimeout(() => { msearch.hidden = true; }, 280);
    if (msearchInput) msearchInput.value = '';
    if (msearchResults) msearchResults.innerHTML = '';
    document.body.style.overflow = '';
  };
  if (msearchOpenBtn) msearchOpenBtn.addEventListener('click', openMSearch);
  if (msearchClose) msearchClose.addEventListener('click', closeMSearch);

  let mSearchTimer;
  if (msearchInput) {
    msearchInput.addEventListener('input', (e) => {
      clearTimeout(mSearchTimer);
      const q = e.target.value.trim();
      if (!q) { msearch.classList.remove('has-results'); if (msearchResults) msearchResults.innerHTML = ''; return; }
      mSearchTimer = setTimeout(() => runSearch(q, true), 200);
    });
  }

  async function runSearch(query, mobile) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
      const res = await fetch(url);
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (!products.length) { handleEmpty(mobile); return; }

      let html = '<div class="pmm-search__results-list">';
      products.forEach(p => {
        const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}&width=120" alt="" width="60" height="60" loading="lazy">` : '';
        const price = p.price ? formatMoney(p.price) : '';
        html += `<a href="${p.url}" class="pmm-search__result"><div class="pmm-search__result-img">${img}</div><div class="pmm-search__result-text"><div class="pmm-search__result-title">${escape(p.title)}</div><div class="pmm-search__result-meta"><span class="pmm-search__result-price">${price}</span></div></div></a>`;
      });
      html += '</div>';

      if (mobile) renderMobile(html, false);
      else {
        if (stateNoResults) stateNoResults.hidden = true;
        if (stateResults) { stateResults.hidden = false; stateResults.innerHTML = html; }
        showPanel();
      }
    } catch (err) { console.error('[pmm] search error', err); }
  }

  function handleEmpty(mobile) {
    if (mobile) { renderMobile('', true); return; }
    if (stateResults) { stateResults.hidden = true; stateResults.innerHTML = ''; }
    if (stateNoResults) stateNoResults.hidden = false;
    showPanel();
  }

  function renderMobile(html, isEmpty) {
    if (!msearchResults) return;
    msearchResults.innerHTML = isEmpty ? '<div class="pmm-search__empty" style="color:rgba(255,255,255,0.6)">No results. Try a different search.</div>' : html;
    msearch.classList.add('has-results');
  }

  function escape(s) { return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function formatMoney(price) {
    let n = typeof price === 'string' ? parseFloat(price) : price;
    if (n > 1000) n = n / 100;
    return '£' + n.toFixed(2);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeAllDropdowns();
    if (searchWrap && searchWrap.classList.contains('is-open')) closeSearch();
    if (msearch && msearch.classList.contains('is-open')) closeMSearch();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', pmmInit);
} else {
  pmmInit();
}

/* Mega menu: stop it closing when a smaller sub-menu opens, while letting it shrink to fit */ (function(){var st=document.createElement('style');st.textContent='.pmm__panel.pmm--hold{background:transparent!important;box-shadow:none!important;border-bottom-color:transparent!important}.pmm__panel.pmm--hold .pmm__subpanel{background:#fff;box-shadow:0 12px 28px rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.08)}';document.head.appendChild(st);function release(p){p.style.minHeight='';p.classList.remove('pmm--hold');}function pmmFixHeight(){document.querySelectorAll('.pmm__panel').forEach(function(p){if(p.dataset.pmmFix)return;p.dataset.pmmFix='1';p.querySelectorAll('.pmm__subpanel').forEach(function(s){s.addEventListener('pointerenter',function(){release(p);});});new MutationObserver(function(){if(p.hasAttribute('data-pmm-sub-open')){if(!p.dataset.pmmHeld&&p.dataset.pmmH){p.dataset.pmmHeld='1';p.style.minHeight=p.dataset.pmmH+'px';p.classList.add('pmm--hold');}}else{delete p.dataset.pmmHeld;if(p.classList.contains('pmm--hold')||p.style.minHeight)release(p);if(p.offsetHeight)p.dataset.pmmH=p.offsetHeight;}}).observe(p,{attributes:true,attributeFilter:['data-pmm-sub-open','class']});});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',pmmFixHeight);}else{pmmFixHeight();}})();